import { defineMessages } from 'react-intl';

export const termsCheckboxMessages = defineMessages({
  termsAgreementWithLinks: {
    defaultMessage:
      'I have read and agree to abide by the <usagePolicy>Usage Policy</usagePolicy>, <privacyPolicy>Privacy Policy</privacyPolicy> <and>and</and> <termsOfUse>Terms of Use</termsOfUse>',
    id: 'pdSfgWZj3J',
    description:
      'Signup terms acceptance line with links to usage policy, privacy policy, and terms of use',
  },
});
